/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArchiveBoxIcon16Light } from './ArchiveBoxIcon16Light';
import { ArchiveBoxIcon16Regular } from './ArchiveBoxIcon16Regular';
import { ArchiveBoxIcon16Solid } from './ArchiveBoxIcon16Solid';
import { ArchiveBoxIcon20Light } from './ArchiveBoxIcon20Light';
import { ArchiveBoxIcon20Regular } from './ArchiveBoxIcon20Regular';
import { ArchiveBoxIcon20Solid } from './ArchiveBoxIcon20Solid';
import { ArchiveBoxIcon24Regular } from './ArchiveBoxIcon24Regular';
import { ArchiveBoxIcon24Solid } from './ArchiveBoxIcon24Solid';
import { ArchiveBoxIcon32Regular } from './ArchiveBoxIcon32Regular';
import { ArchiveBoxIcon64Regular } from './ArchiveBoxIcon64Regular';
var sizes = {
    16: {
        light: ArchiveBoxIcon16Light,
        regular: ArchiveBoxIcon16Regular,
        solid: ArchiveBoxIcon16Solid,
    },
    20: {
        light: ArchiveBoxIcon20Light,
        regular: ArchiveBoxIcon20Regular,
        solid: ArchiveBoxIcon20Solid,
    },
    24: {
        regular: ArchiveBoxIcon24Regular,
        solid: ArchiveBoxIcon24Solid,
    },
    32: {
        regular: ArchiveBoxIcon32Regular,
    },
    64: {
        regular: ArchiveBoxIcon64Regular,
    },
};
export var ArchiveBoxIcon = forwardRef('ArchiveBoxIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
